import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  object,
  number,
  boolean,
} from 'libs/form';

interface FinancialInstruments {
  yearlyTradeAmount?: number;
  monthlyTradeAmount?: number;
  enabled?: boolean;
}

export interface TargetedFinancialInstrumentsFormType {
  targetedFinancialInstruments: {
    expectedMonthlyTradeQuantity?: number;
    expectedYearlyTradeQuantity?: number;

    financialInstruments: {
      stocks?: FinancialInstruments;
      bonds?: FinancialInstruments;
      mutualFunds?: FinancialInstruments;
      derivatives?: FinancialInstruments;
      structuredProducts?: FinancialInstruments;
      otherFinancialInstruments?: FinancialInstruments;
    };
  };
}

const financialInstrumentsSchema = object({
  enabled: boolean().default(false),
  yearlyTradeAmount: number().when('enabled', {
    is: true,
    then: (schema) => schema.required(),
  }),
  monthlyTradeAmount: number(),
});

export const getTargetedFinancialInstrumentsSchema =
  (): ObjectSchema<TargetedFinancialInstrumentsFormType> =>
    object({
      targetedFinancialInstruments: object({
        expectedMonthlyTradeQuantity: number().required(),
        expectedYearlyTradeQuantity: number().required(),

        financialInstruments: object({
          stocks: financialInstrumentsSchema,
          bonds: financialInstrumentsSchema,
          mutualFunds: financialInstrumentsSchema,
          derivatives: financialInstrumentsSchema,
          structuredProducts: financialInstrumentsSchema,
          otherFinancialInstruments: financialInstrumentsSchema,
        }),
      }),
    });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<TargetedFinancialInstrumentsFormType>();

export type FormErrors = FormErrorsBase<TargetedFinancialInstrumentsFormType>;
